import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { theme } from 'theme';
import { LegendColorChip } from 'ui/ColorChips/LegendColorChip';
import { StatisticsItem } from 'modules/common/PortfolioManager/types';
import { useReportPage } from 'shared/hooks';

const useStyles = makeStyles({
  chipSpacing: {
    marginRight: theme.spacing(1),
  },
  bold: {
    fontWeight: 900,
  },
  nameCapitalized: {
    textTransform: 'capitalize',
  },
  iconButtonStyling: {
    padding: '0',
    color: 'black',
  },
});

type PortfolioChartLegendProps = {
  items: StatisticsItem[];
  otherItemsToExpand?: StatisticsItem[];
  hideLegendChip?: Boolean;
  colors: string[];
};

export const PortfolioChartLegend: FC<PortfolioChartLegendProps> = ({
  items,
  otherItemsToExpand = [],
  hideLegendChip,
  colors,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [isCollapsed, changeCollapse] = useState(false);
  const renderCollapseButton = (name: string) => {
    if (name === t('OTHER')) {
      return (
        <IconButton
          className={classes.iconButtonStyling}
          onClick={() => changeCollapse(!isCollapsed)}
          size="large">
          {isCollapsed ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      );
    }
    return '';
  };
  return (
    <>
      {items.map(({ name, count }, index) => (
        <React.Fragment key={name}>
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" alignItems="center">
              <LegendColorChip
                className={classes.chipSpacing}
                chipColor={hideLegendChip ? 'white' : colors[index]}
              />
              <Typography variant="body1" className={clsx(classes.nameCapitalized, classes.bold)}>
                {name}
              </Typography>
              {renderCollapseButton(name)}
            </Box>
            <Typography variant="body1" className={classes.bold}>
              {count}%
            </Typography>
          </Box>
          <Box py={2} pt={useReportPage ? 1 : 2}>
            <Divider />
          </Box>
          {name === t('OTHER') && otherItemsToExpand.length && isCollapsed && (
            <PortfolioChartLegend items={otherItemsToExpand} colors={colors} hideLegendChip />
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default PortfolioChartLegend;
